module.exports = __webpack_public_path__ + "static/img/products-grey.77d6c7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/sidebar/products-grey.svg
// module id = 618
// module chunks = 2